<template>
  <AppLayout>
    <!-- SLOT: NAVBAR MENU -->
    <NavbarMenu slot="navbar-menu" />
    <!-- SLOT: MENU DRAWER -->
    <MenuDrawer slot="menu-drawer" />
    <!-- SLOT: TOOL DRAWER -->
    <ToolDrawer slot="tool-drawer" />

    <slot name="main" slot="main"></slot>
  </AppLayout>
</template>

<script>
import AppLayout from "@/layouts/AppLayout0.vue";
import NavbarMenu from "@/components/real-estate/NavbarMenu.vue";
import MenuDrawer from "@/components/real-estate/MenuDrawer.vue";
import ToolDrawer from "@/components/real-estate/ToolDrawer.vue";

export default {
  components: {
    AppLayout,
    NavbarMenu,
    MenuDrawer,
    ToolDrawer,
  },
};
</script>

<style></style>
